import { createReducer, on } from '@ngrx/store';

export const initialState = null;
import { loadRates, ratesLoaded, rehydrateRates, ratesLoadedFailed, loadRatesHappy, resetRates, saveRatesRequest } from '../_actions/rates.actions';
import { state } from '@angular/animations';

const _ratesReducer = createReducer(initialState,
    on(loadRates, (state) => console.log('Load Rates', state)),
    on(loadRatesHappy, (state) => console.log('Load Rates Happy', state)),
    on(ratesLoaded, (state, payload) => {
      console.log('Rates Loaded Success',state, payload);
      const filteredPayload = payload?.data?.productDetailsList
        ? {
            ...payload,
            data: {
              ...payload.data,
              productDetailsList: payload.data.productDetailsList.filter(
                (product) => product?.statusCode === 100
              ),
            },
          }
        : payload;
      // To add a lead to state, use spread operator
      window.sessionStorage.setItem('rates', JSON.stringify(filteredPayload));
      return filteredPayload;
    }),
    on(rehydrateRates, (state, payload) => {
      // console.log('Rates Rehydrated', state, payload)
      sessionStorage.setItem('rates', JSON.stringify(payload))
      return payload;
    }),
    on(ratesLoadedFailed, (state, payload) => {
      console.log('Rates Loaded Failed', state, payload)
      sessionStorage.setItem('rates', JSON.stringify(payload))
      return payload;
    }),
    on(resetRates, (state, payload) => {
      window.sessionStorage.removeItem('rates')
      return null
    }),
    on(saveRatesRequest, (state, payload) => {
      window.sessionStorage.setItem('ratesRequest', JSON.stringify(payload))
      return state
    })
);

export function ratesReducer(state, action) {
    return _ratesReducer(state, action);
}
